import * as types from "./types";

export const defaultState = {
  circles: {},
  loading: false,
  errors: [],
};

const rentable_circles = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHING_RENTABLE_CIRCLES:
      return {
        ...state,
        loading: action.loading
      };
    case types.FETCHED_RENTABLE_CIRCLES:
      // debugger;
      // const new_circles = _.keyBy(action.circles, "guid");
      return {
        ...state,
        circles: { ...state.circles, ...action.circles },
        loading: action.loading
      };
    case types.ERROR_FETCHING_RENTABLE_CIRCLES:
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: action.loading
      };

    default:
      return state;
  }
};
export default rentable_circles;
